if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // if(document.querySelector('.custom-block-option') != null){
        //   if(document.querySelector('[name="Charger Model"]') != null){
        //     if (document.querySelector('[name="Charger Skin"]').checked && document.querySelector('[name="Charger Model"]').value == ''){
        //       document.querySelector('.gpo-helptext').classList.remove('hidden');
        //       console.log('in');
        //       return;
        //     }  
        //   }
        // }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // var main_this = this;

        // if(document.querySelector('.custom-block-option') != null){

        //     var store_id = [];
        //     var time_stamp = Date.now();

        //     if(document.querySelector('[name="Screen Protector"]').checked){
        //       store_id.push({id:47273110667549,quantity:1,properties: {"addonproduct": true,"timestamp":time_stamp}});
        //     }
            
        //     if(document.querySelector('[name="Charger Skin"]').checked){
        //       store_id.push({id:47273113780509,quantity:1,properties: {"addonproduct": true,"timestamp":time_stamp}});
        //     }
            
        //     if(document.querySelector('[name="Slider Grip"]').checked){
        //       store_id.push({id:47273115549981,quantity:1,properties: {"addonproduct": true,"timestamp":time_stamp}});
        //     }

        //     if(store_id.length > 0){
        //       $.ajax({
        //           type: 'POST',
        //           url: '/cart/add.js',
        //           data: {
        //             "items": store_id
        //           },
        //           dataType: 'json', 
        //           success: function (data) { 
        //               const config = fetchConfig('javascript');
        //               config.headers['X-Requested-With'] = 'XMLHttpRequest';
        //               delete config.headers['Content-Type'];
              
                      
        //               var input = document.createElement("input");
        //               input.type = "hidden";
        //               input.name = "properties[timestamp]";
        //               input.value = time_stamp;
        //               main_this.form.appendChild(input);
        //               var input2 = document.createElement("input");
        //               input2.type = "hidden";
        //               input2.name = "properties[mainProd]";
        //               input2.value = true;
        //               main_this.form.appendChild(input2);
        //               const formData = new FormData(main_this.form);
        //               if (main_this.cart) {
        //                 formData.append(
        //                   'sections',
        //                   main_this.cart.getSectionsToRender().map((section) => section.id)
        //                 );
        //                 formData.append('sections_url', window.location.pathname);
        //                 main_this.cart.setActiveElement(document.activeElement);
        //               }
        //               config.body = formData;
              
        //               fetch(`${routes.cart_add_url}`, config)
        //                 .then((response) => response.json())
        //                 .then((response) => {
        //                   if (response.status) {
        //                     publish(PUB_SUB_EVENTS.cartError, {
        //                       source: 'product-form',
        //                       productVariantId: formData.get('id'),
        //                       errors: response.errors || response.description,
        //                       message: response.message,
        //                     });
        //                     main_this.handleErrorMessage(response.description);
              
        //                     const soldOutMessage = main_this.submitButton.querySelector('.sold-out-message');
        //                     if (!soldOutMessage) return;
        //                     main_this.submitButton.setAttribute('aria-disabled', true);
        //                     main_this.submitButton.querySelector('span').classList.add('hidden');
        //                     soldOutMessage.classList.remove('hidden');
        //                     main_this.error = true;
        //                     return;
        //                   } else if (!main_this.cart) {
        //                     window.location = window.routes.cart_url;
        //                     return;
        //                   }
              
        //                   if (!main_this.error)
        //                     publish(PUB_SUB_EVENTS.cartUpdate, {
        //                       source: 'product-form',
        //                       productVariantId: formData.get('id'),
        //                       cartData: response,
        //                     });
        //                   main_this.error = false;
        //                   const quickAddModal = main_this.closest('quick-add-modal');
        //                   if (quickAddModal) {
        //                     document.body.addEventListener(
        //                       'modalClosed',
        //                       () => {
        //                         setTimeout(() => {
        //                           main_this.cart.renderContents(response);
        //                         });
        //                       },
        //                       { once: true }
        //                     );
        //                     quickAddModal.hide(true);
        //                   } else {
        //                     main_this.cart.renderContents(response);
        //                   }
        //                 })
        //                 .catch((e) => {
        //                   console.error(e);
        //                 })
        //                 .finally(() => {
        //                   main_this.submitButton.classList.remove('loading');
        //                   if (main_this.cart && main_this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        //                   if (!main_this.error) main_this.submitButton.removeAttribute('aria-disabled');
        //                   main_this.querySelector('.loading__spinner').classList.add('hidden');
        //                 });
        //           } 
        //       });
        //     }else{
        //       const config = fetchConfig('javascript');
        //       config.headers['X-Requested-With'] = 'XMLHttpRequest';
        //       delete config.headers['Content-Type'];
      
        //       const formData = new FormData(this.form);
        //       if (this.cart) {
        //         formData.append(
        //           'sections',
        //           this.cart.getSectionsToRender().map((section) => section.id)
        //         );
        //         formData.append('sections_url', window.location.pathname);
        //         this.cart.setActiveElement(document.activeElement);
        //       }
        //       config.body = formData;
      
        //       fetch(`${routes.cart_add_url}`, config)
        //         .then((response) => response.json())
        //         .then((response) => {
        //           if (response.status) {
        //             publish(PUB_SUB_EVENTS.cartError, {
        //               source: 'product-form',
        //               productVariantId: formData.get('id'),
        //               errors: response.errors || response.description,
        //               message: response.message,
        //             });
        //             this.handleErrorMessage(response.description);
      
        //             const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        //             if (!soldOutMessage) return;
        //             this.submitButton.setAttribute('aria-disabled', true);
        //             this.submitButton.querySelector('span').classList.add('hidden');
        //             soldOutMessage.classList.remove('hidden');
        //             this.error = true;
        //             return;
        //           } else if (!this.cart) {
        //             window.location = window.routes.cart_url;
        //             return;
        //           }
      
        //           if (!this.error)
        //             publish(PUB_SUB_EVENTS.cartUpdate, {
        //               source: 'product-form',
        //               productVariantId: formData.get('id'),
        //               cartData: response,
        //             });
        //           this.error = false;
        //           const quickAddModal = this.closest('quick-add-modal');
        //           if (quickAddModal) {
        //             document.body.addEventListener(
        //               'modalClosed',
        //               () => {
        //                 setTimeout(() => {
        //                   this.cart.renderContents(response);
        //                 });
        //               },
        //               { once: true }
        //             );
        //             quickAddModal.hide(true);
        //           } else {
        //             this.cart.renderContents(response);
        //           }
        //         })
        //         .catch((e) => {
        //           console.error(e);
        //         })
        //         .finally(() => {
        //           this.submitButton.classList.remove('loading');
        //           if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        //           if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        //           this.querySelector('.loading__spinner').classList.add('hidden');
        //         });
        //     }
            
        // }else{
        //   const config = fetchConfig('javascript');
        //   config.headers['X-Requested-With'] = 'XMLHttpRequest';
        //   delete config.headers['Content-Type'];
  
        //   const formData = new FormData(this.form);
        //   if (this.cart) {
        //     formData.append(
        //       'sections',
        //       this.cart.getSectionsToRender().map((section) => section.id)
        //     );
        //     formData.append('sections_url', window.location.pathname);
        //     this.cart.setActiveElement(document.activeElement);
        //   }
        //   config.body = formData;
  
        //   fetch(`${routes.cart_add_url}`, config)
        //     .then((response) => response.json())
        //     .then((response) => {
        //       if (response.status) {
        //         publish(PUB_SUB_EVENTS.cartError, {
        //           source: 'product-form',
        //           productVariantId: formData.get('id'),
        //           errors: response.errors || response.description,
        //           message: response.message,
        //         });
        //         this.handleErrorMessage(response.description);
  
        //         const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        //         if (!soldOutMessage) return;
        //         this.submitButton.setAttribute('aria-disabled', true);
        //         this.submitButton.querySelector('span').classList.add('hidden');
        //         soldOutMessage.classList.remove('hidden');
        //         this.error = true;
        //         return;
        //       } else if (!this.cart) {
        //         window.location = window.routes.cart_url;
        //         return;
        //       }
  
        //       if (!this.error)
        //         publish(PUB_SUB_EVENTS.cartUpdate, {
        //           source: 'product-form',
        //           productVariantId: formData.get('id'),
        //           cartData: response,
        //         });
        //       this.error = false;
        //       const quickAddModal = this.closest('quick-add-modal');
        //       if (quickAddModal) {
        //         document.body.addEventListener(
        //           'modalClosed',
        //           () => {
        //             setTimeout(() => {
        //               this.cart.renderContents(response);
        //             });
        //           },
        //           { once: true }
        //         );
        //         quickAddModal.hide(true);
        //       } else {
        //         this.cart.renderContents(response);
        //       }
        //     })
        //     .catch((e) => {
        //       console.error(e);
        //     })
        //     .finally(() => {
        //       this.submitButton.classList.remove('loading');
        //       if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        //       if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        //       this.querySelector('.loading__spinner').classList.add('hidden');
        //     });
        // }

        const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
  
          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
  
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);
  
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }
  
              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
            });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
